<app-eca-modal-host [heading]="headerText" (saveClicked)="saveClicked()"
                    (editClicked)="editClicked()"
                    (cancelClicked)="cancelBtnClicked()"
                    (helpClicked)="helpClicked()"
                    [isEditing]="isEditing"
                    [yesButtonIcon]="['far', 'save']"
                    [noButtonIcon]="['far', 'times']"
                    noButtonColour="transparent">
  <div class="container">
    <div class="row" *ngIf="showingHelp">
      <div class="col">
        <app-eca-help-alert [helpHtmlText]="helpText" (helpCloseClicked)="helpClicked()"></app-eca-help-alert>
      </div>
    </div>
    <app-document-uploader *ngIf="documentTypes && tempDocumentSummary"
                           [documentSummary]="tempDocumentSummary" [saveAttempted]="saveAttempted"
                           [submitted]="saveAttempted"
                           (fileUpload)="fileUploaded($event)"
                           (fileRemove)="removeFile($event)"
                           [documentTypes]="documentTypes"
                           [isEditing]="isEditing" (canSave)="canSaveDocument($event)">
    </app-document-uploader>
  </div>
</app-eca-modal-host>
